import { render } from "./DetailItemCard.vue?vue&type=template&id=0a06c0ef&scoped=true"
import script from "./DetailItemCard.vue?vue&type=script&lang=js"
export * from "./DetailItemCard.vue?vue&type=script&lang=js"

import "./DetailItemCard.vue?vue&type=style&index=0&id=0a06c0ef&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a06c0ef"]])

export default __exports__